module.exports = __webpack_public_path__ + "assets/img/202107-1.2caa5a16.png";